import React, { useState, useRef, useEffect, useImperativeHandle, forwardRef } from 'react';
import { ApiCore } from '../../../api/index';
import { Switch, Toast, Button } from 'antd-mobile-v5';
import { withRouter } from 'react-router-dom';
import styles from './index.module.scss';
import medical_consultant from '../../../static/images_cso/medical_consultant.png';
import xiaohui_medical_consultant from '../../../static/images_cso/xiaohui_medical_consultant.png';
import medical_heart from '../../../static/images_cso/medical_heart.png';
import close from '../../../static/images_cso/close.png';

let env = process.env.REACT_APP_ENV;

const api = new ApiCore();

const MedicalConsult = (props: any, refs: any) => {

    const [showDialog, setShowDialog] = useState<boolean>(true);
    const [imgUrl, setImgUrl] = useState<string>('');

    useEffect(() => {
        initData();
        return () => {
        }
    }, [])

    // 展示弹框
    useImperativeHandle(refs, () => ({
        toShow,
        toClose
    }));

    const initData = () => {
        const tenantCode = localStorage.getItem('tenantCode');
        if (env === 'test' || env === 'development') {
            // 测试环境
            setImgUrl(tenantCode === 'TENANT-024' ? xiaohui_medical_consultant : 'https://huimei-edc.oss-cn-shanghai.aliyuncs.com/edc/data/image/upload_to_oss_component/cso/doctor/medical_consultant_gaoji_20231222.png'); // 014 -> 众生（高济） 024 -> 小惠
        } else {
            // 线上环境
            setImgUrl(tenantCode === 'TENANT-034' ? xiaohui_medical_consultant : 'https://huimei-edc.oss-cn-shanghai.aliyuncs.com/edc/data/image/upload_to_oss_component/cso/doctor/medical_consultant_gaoji_20231222.png'); // 029 -> 众生（高济） 034 -> 小惠
        }
    }

    const toShow = () => {
        setShowDialog(true);
    }

    const toClose = () => {
        setShowDialog(false);
    }

    return (
        <div className={styles.medical_consult_content} style={{ display: showDialog ? 'block' : 'none' }}>
             <div className={styles.dialog}>
                <div className={styles.title}>欢迎入驻</div>
                <div className={styles.content}>请添加您的线上助手，有新品上市和平台活动时，将第一时间通知您，并为您提供更好的咨询服务</div>
                <div className={styles.shop_wrap}>
                    <div className={styles.medical_consultant_wrap}>
                        <img className={styles.medical_heart} src={medical_heart} alt="" />
                        <img className={styles.medical_consultant} src={imgUrl} alt="" />
                    </div>
                </div>
                <div className={styles.word}>长按识别 一键添加</div>
                <div className={styles.close_wrap}>
                    <img src={close} onClick={toClose} alt="" />
                </div>
             </div>
             <div className={styles.mask}></div>
        </div>
    )
}

export default forwardRef(MedicalConsult);